import { NewsletterSectionTypes, type NewsletterFormTypes } from '@ramp106/omrjs-core-ui'
import { ref } from 'vue'

import { captchaSitekey } from '@/helpers/captcha'

import { useRuntimeConfig } from '#imports'

export const useNewsletterSubmit = (audience?: string | null) => {
  const {
    public: { myomrHost },
  } = useRuntimeConfig()

  const status = ref<NewsletterSectionTypes.NewsletterFormStatus>(NewsletterSectionTypes.NewsletterFormStatus.Idle)

  const submit = (formData: NewsletterFormTypes.NewsletterFormData) => {
    status.value = NewsletterSectionTypes.NewsletterFormStatus.Busy

    const data = {
      user: {
        audiences: [audience].filter((el) => el),
        email: formData.email,
        first_name: formData.firstName,
        last_name: formData.lastName,
      },
      captcha: {
        solution: formData.captchaSolution,
        sitekey: captchaSitekey,
      },
    }

    fetch(`${myomrHost}/api/v1/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(() => {
        status.value = NewsletterSectionTypes.NewsletterFormStatus.Success
      })
      .catch(() => {
        status.value = NewsletterSectionTypes.NewsletterFormStatus.Error
      })
  }

  return { status, submit }
}
